import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '../../../environments/environment';
import { GetterSetterService } from '../services/getter-setter.service';

/** Appends the signed-in user's tenantId to API requests when available. */
export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiBaseUrl) || req.params.has('tenantId')) {
    return next(req);
  }

  const getSet = inject(GetterSetterService);
  const tenantId = String(getSet.getUserDetails()?.tenantId ?? '').trim();

  if (!tenantId) {
    return next(req);
  }

  return next(
    req.clone({
      // params: req.params.set('tenantId', tenantId),
    }),
  );
};
